module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/day-in-the-life-poster-eaa58ba195ab7d36d332b7954c64a822.jpg";